import { getInvestingProfileName } from "../../CaseDetailsDrawer/Profiles/utils";
import { ProfileNameFields } from "../../utils/types";
import { PositionsTableRowItem } from "../types";

export const formatOnboardingStatus = (position: PositionsTableRowItem): string => {
  if (!position.onboardingStatus) {
    return "Action Required";
  }

  const caseName =
    position.onboardingStatus.name ??
    getInvestingProfileName(position.onboardingStatus.investingProfile as ProfileNameFields);
  const parts = [];

  parts.push(`Case ID: ${position.onboardingStatus.id}`);
  parts.push(`Case Name: ${caseName}`);
  parts.push(`Case Status: ${position.onboardingStatus.status}`);
  return JSON.stringify(parts);
};

export const generatePositionsCSV = (
  positions: PositionsTableRowItem[],
  headers: string[],
): string => {
  const rows = positions.map((position) => [
    `${position.position?.accountName} in ${position.position?.entityName}` || "",
    position.entity?.name || "",
    position.client?.name || "",
    position.status || "",
    position.investingAccount || "",
    position.date,
    position.program?.join(", ") || "",
    position.riskRating || "N/A",
    formatOnboardingStatus(position),
  ]);

  return [headers, ...rows]
    .map((row) => row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(","))
    .join("\n");
};

export const downloadCSVFile = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const formatExportFilename = (): string => {
  const now = new Date();
  const timestamp = now.toISOString().split("T")[0];
  return `Compliance_Positions_${timestamp}.csv`;
};
